<template>
  <div style="width: 100%; min-height: 100vh; background: rgb(237, 241, 255)">
    <van-nav-bar style="position: fixed; top: 0; left: 0; width: 100%; background-color: #f7f8fa" title="活动申请记录" left-arrow @click-left="$router.back()" />
    <div style="height: 46px"></div>
    <div style="width: 95%; min-width: 250px; margin: 0 auto; background: #fff; border-radius: 10px; box-sizing: border-box; padding: 10px; min-height: 90vh">
  
   
    
        <van-list style="margin-top: 10px; padding-bottom: 120px" finished-text="没有更多了" offset="300" v-model="loading" :finished="list.length == pageData.total" @load="getData" v-if="list.length > 0">
          <van-cell v-for="(item, index) in list" :key="index">
            <div class="rec-item">
              <div class="rec-item__head">
                <span class="rec-item__name">{{ item.activity_name }}</span>
                <span class="rec-item__state" :style="{ color: stateColor(item.state) }">{{ statuTypeS[item.state] }}</span>
              </div>
              <!-- 通过发放：到账通知 -->
              <div v-if="item.state == 2" class="rec-item__paid">🎉 彩金 <b>{{ item.grant_amount }}</b> 元已发放至中心钱包，可直接使用</div>
              <!-- 拒绝：理由 -->
              <div v-else-if="item.state == 3" class="rec-item__reject">未通过{{ item.remark ? '：' + item.remark : '，如有疑问请联系客服' }}</div>
              <!-- 待审核 -->
              <div v-else class="rec-item__pending">审核中，请耐心等待</div>
              <div class="rec-item__meta" v-if="Number(item.apply_amount) > 0">申请金额：{{ item.apply_amount }} 元</div>
              <div class="rec-item__meta" v-if="item.state == 1 && item.remark">备注：{{ item.remark }}</div>
              <div class="rec-item__meta">申请时间：{{ item.created_at }}</div>
              <div class="rec-item__meta" v-if="item.check_time && item.state != 1">审核时间：{{ item.check_time }}</div>
            </div>
          </van-cell>
        </van-list>
      <div v-else style="margin-top: 60px; text-align: center">
        <img src="/static/image/mescroll-empty.png" style="width: 35%" alt="" />
        <van-divider dashed :style="{ color: '#ccc', borderColor: '#ccc', padding: '20px ' }">空空如也</van-divider>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  name: 'activityRecord',
  data() {
    return {
      list: [],
      pageData: {},
      page: 1,
      loading: false,
      statuTypeS: ['', '待审核', '已通过发放', '已拒绝', ''],
    };
  },
  created() {
    let that = this;
    that.getData();
  },
  methods: {
    stateColor(s) {
      return s == 2 ? '#07c160' : s == 3 ? '#ee0a24' : '#ff976a';
    },
    getData() {
      let that = this;
      let page = that.page;
      if (page > that.pageData.last_page) {
        that.loading = false;

        return;
      }
      that.$parent.showLoading();
      let info = {
        page: that.page,
      };
      that.$apiFun
        .post('/api/activityApplyLog', info)
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.pageData = res.data;

            if (that.page == 1) {
              that.list = res.data.data;
            } else {
              let list = JSON.parse(JSON.stringify(that.list));
              res.data.data.forEach(el => {
                list.push(el);
              });
              that.list = list;
            }
            that.page = page + 1;
          }
          that.loading = false;
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
          that.loading = false;
        });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
.rec-item {
  font-size: 13px;
  line-height: 1.7;
  &__head {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__name {
    color: #333;
    font-weight: 600;
  }
  &__state {
    font-size: 13px;
    font-weight: 600;
  }
  &__paid {
    margin: 8px 0;
    padding: 8px 10px;
    background: #e8f8ee;
    border: 1px solid #c3ecd3;
    border-radius: 6px;
    color: #07915a;
    b {
      color: #e4393c;
      font-size: 15px;
    }
  }
  &__reject {
    margin: 8px 0;
    padding: 8px 10px;
    background: #fdecec;
    border: 1px solid #f7c5c5;
    border-radius: 6px;
    color: #d33;
  }
  &__pending {
    margin: 8px 0;
    padding: 8px 10px;
    background: #fff7e6;
    border: 1px solid #ffe0a3;
    border-radius: 6px;
    color: #b8770a;
  }
  &__meta {
    color: #888;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/activityRecord.vue